module.exports = __webpack_public_path__ + "img/scene2.e12a1368.jpg";